import {MRT_Row} from 'material-react-table';
import React from 'react';
import {Tag, designSystemToken} from '@lightricks/react-design-system';
import {type BrandedContentAdsPartnership} from '@/types/brandedContentAdsPartnership';
import styles from './StatusCell.module.scss';

function StatusCell({row}: {row: MRT_Row<BrandedContentAdsPartnership>}) {
  const status = row.original.status || '';
  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '-');

  const getStatusConfig = () => {
    switch (normalizedStatus) {
      case 'pending-approval':
        return {
          text: 'Pending Approval',
          backgroundColor: designSystemToken('reference.yellow.10'),
          textColor: designSystemToken('reference.yellow.50'),
        };
      case 'approved':
        return {
          text: 'Approved',
          backgroundColor: designSystemToken('reference.green.10'),
          textColor: designSystemToken('reference.green.50'),
        };
      case 'rejected':
        return {
          text: 'Rejected',
          backgroundColor: designSystemToken('reference.red.10'),
          textColor: designSystemToken('reference.red.50'),
        };
      default:
        return {
          text: status || 'Unknown',
          backgroundColor: designSystemToken('reference.gray.050'),
          textColor: designSystemToken('reference.gray.500'),
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <div className={styles.container}>
      <Tag
        text={statusConfig.text}
        backgroundColor={statusConfig.backgroundColor}
        textColor={statusConfig.textColor}
      />
    </div>
  );
}

export default StatusCell;
